import { Container, Heading, Icon } from "@fluidattacks/design";
import { useTheme } from "styled-components";

import type { IVulnerabilityModalHeaderTitle } from "../../types";
import { getOriginIcon } from "features/vulnerabilities/utils";

const VulnerabilityModalHeaderTitle: React.FC<
  IVulnerabilityModalHeaderTitle
> = ({
  locationTitle,
  origin,
}: Readonly<IVulnerabilityModalHeaderTitle>): JSX.Element => {
  const theme = useTheme();

  return (
    <Container
      alignItems={"flex-start"}
      display={"inline-flex"}
      flexDirection={"column"}
      width={"80%"}
    >
      <Container alignItems={"center"} display={"flex"} width={"100%"}>
        <Container
          alignItems={"center"}
          display={"flex"}
          gap={0.5}
          width={"100%"}
        >
          <Icon
            icon={getOriginIcon(origin)}
            iconColor={theme.palette.gray[800]}
            iconSize={"lg"}
            iconType={"fa-light"}
          />
          <Heading
            fontWeight={"bold"}
            overflow={"hidden"}
            size={"sm"}
            textOverflow={"ellipsis"}
            whiteSpace={"nowrap"}
          >
            {locationTitle}
          </Heading>
        </Container>
      </Container>
    </Container>
  );
};

export { VulnerabilityModalHeaderTitle };
